export const VIDEO_LOCAL_CLIPS_FETCH_LIMIT = 5;
